import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

import MetricChart from './MetricCharts';
import MetricFilter from './MetricFilter';
import { MetricGuideline } from './metricGuideline/MetricGuideline';
import {
    useGetCoachingMonthlyMetricsQuery,
    useGetCoachingScorecardQuery,
    useInsertCoachingMetricsMutation,
    useInsertCoachingScorecardMutation,
} from './metricsSlice';
import { setMetricChartHandleSave } from '../../../pages/login/authSlice';
import { hideLoader, showLoader } from '../../../components/loadingSpinner/loadingspinner';
import { CoachingEntityTypes } from '../../../utils/typeConstants';

interface Metric {
    setDisplayModal: (e: boolean) => void;
    displayModal: boolean;
    authorId: string;
    inputYear?: number;
    inputMonth?: number;
    recipientId: string;
    recipientName: string;
    inputScorecardId?: number;
    metricId?: number;
    // via?: number;
    gameplanId?: number;
    entityTypeId: number;
}

const MetricModal = (props: Metric) => {
    const dispatch = useDispatch();
    const [scorecardId, setScorecardId] = useState<number>(0);
    const [scorecardVersionId, setScorecardVersionId] = useState<number>(0);
    const [metrics, setMetrics] = useState<number[]>([]);
    const [coachingScorecardData, setCoachingScorecardData] = useState<any>([]);
    const [insertCoachingScorecard] = useInsertCoachingScorecardMutation();
    const [insertCoachingMetrics] = useInsertCoachingMetricsMutation();
    const [displayGuidline, setDisplayGuidline] = useState<boolean>(false);
    // Inside MetricModal component

    useEffect(() => {
        dispatch(setMetricChartHandleSave('false'));
    }, []);

    const { data: coachingScorecardAPIData } = useGetCoachingScorecardQuery(
        {
            employeeNumber: props.recipientId,
            year: props.inputYear,
            month: props.inputMonth,
            scorecardId,
            // scorecardVersionId,
        },
        { skip: !props.recipientId || !props.inputYear || !props.inputMonth }
    );

    // Inside MetricModal component
    const { data: coachingMonthlyMetrics } = useGetCoachingMonthlyMetricsQuery(
        {
            employeeNumber: props.recipientId,
            year: props.inputYear,
            month: props.inputMonth,
            scorecardId,
            scorecardVersionId,

        },
        { skip: !props.recipientId || !props.inputYear || !props.inputMonth }
    );

    useEffect(() => {
        if (coachingScorecardData && coachingScorecardData?.data?.length === 0 && metrics.length > 0) {
            const coachingScorecardData = {
                employeeNumber: props?.recipientId,
                authorEmployeeNumber: props?.authorId,
                scorecardId,
                year: props?.inputYear,
                month: props?.inputMonth,
                goalEmployeeNumber: props?.recipientId,
                metricIds: metrics,
                entityTypeId: props?.entityTypeId,
                entityId: props?.entityTypeId === CoachingEntityTypes.Gameplan ? props?.gameplanId : undefined,
            };
            InsertCoachingScorecardData(coachingScorecardData);
        }
        else if (coachingScorecardData?.data?.length > 0 && metrics.length > 0){
            const count = coachingScorecardData?.data[0]?.coaching_metric_ids?.split(',').map((id:any) => id.trim()).filter((id:any) => id !== '').length;
            if (count !== metrics.length) {
                InsertCoachingMetrics(coachingScorecardData?.data[0]?.coaching_scorecard_id);
            }
        }
    }, [coachingScorecardData, metrics]);

    useEffect(() => {
        if (coachingMonthlyMetrics?.data?.length > 0) {
            const array: any = coachingMonthlyMetrics?.data[0].metrics.map((item: any) => {
                return item.metric_id;
            });
            setMetrics(array);
        }
    }, [coachingMonthlyMetrics]);

    useEffect(() => {
        setCoachingScorecardData(coachingScorecardAPIData);
    }, [coachingScorecardAPIData]);

    const InsertCoachingMetrics = (coachingScorecardId: number) => {
        const coachingMetricsData = {
            coachingScorecardId,
            metricIds: metrics,
            authorEmployeeNumber: props?.authorId,
            //goalEmployeeNumber: props?.recipientId,
        };
        
        insertCoachingMetrics(coachingMetricsData)
            .unwrap()
            .then((data: any) => {
                if (data?.data) {
                    return true;
                }
                return toast.error('Create Coaching Metrics failed');
            });
    };

    const InsertCoachingScorecardData = (coachingScorecardData: any) => {
        insertCoachingScorecard(coachingScorecardData)
        .unwrap()
        .then((data: any) => {
            if (data?.data) {
                return true;
            }
            return toast.error('Create Coaching Scorecard failed');
        });
    };

    const renderHeader = () => {
        return (
            <div>
                <h3>Metrics </h3>
            </div>
        );
    };

    const onMetricDialogHide = () => {
        showLoader();
        dispatch(setMetricChartHandleSave('true'));

        setTimeout(() => {
            dispatch(setMetricChartHandleSave('false'));
            setScorecardId(0);
            setScorecardVersionId(0);
            setCoachingScorecardData([]);
            setMetrics([]);
            props.setDisplayModal(false);

            hideLoader();
        }, 1500);
    };

    const renderMetricGuidance = () => {
        return <MetricGuideline displayGuidline={displayGuidline} setDisplayGuidline={setDisplayGuidline} />;
    };

    return (
        <Dialog
            header={renderHeader()}
            visible={props?.displayModal}
            onHide={onMetricDialogHide}
            style={{
                width: '66vw',
                height: '90vh',
            }}
            position="bottom"
            className="MetricDialog card shadow bg-body rounded mt-4 border-0 w-65"
            modal
            draggable={false}
            resizable={false}
        >
            <MetricFilter
                onScorecardChange={setScorecardId}
                setScorecardVersionId={setScorecardVersionId}
                inputYear={props?.inputYear}
                inputMonth={props?.inputMonth}
                recipientId={props?.recipientId}
                inputScorecardId={props?.inputScorecardId}
            />
            {coachingScorecardData?.data?.length > 0 ? (
                <div>
                    <MetricChart
                        // onMetricDialogHide={onMetricDialogHide} 
                        coachingMetric={coachingMonthlyMetrics}
                        coachingScorecardId={coachingScorecardData?.data[0]?.coaching_scorecard_id}
                        receiverName={props?.recipientName}
                        inputMonth={props?.inputMonth}
                        inputYear={props?.inputYear}
                        metricId={props?.metricId}
                        // via={props?.via}
                        // gameplanId={props?.gameplanId}
                    />
                </div>
            ) : (
                <div className="text-center mt-4 mb-4 no-data-label">No Data Available</div>
            )}
            <Divider />
            <Button
                label="Guidelines"
                onClick={() => setDisplayGuidline(true)}
                className="btn-primary"
            />
            {displayGuidline && renderMetricGuidance()}
        </Dialog>
    );
};

export default MetricModal;
